import React, { Component } from 'react'
import Page from 'components/Page'
import PasswordReset from 'features/Auth/PasswordReset'
import sLay from 'styles/modules/layout.scss'

export default class PasswordResetPage extends Component {
  render() {
    return (
      <Page title="Password Reset" className={sLay['layout-column']}>
        <PasswordReset />
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PasswordReset/PasswordReset.jsx